const n = function() {
  let e = () => {
  }, r = () => {
  };
  return {
    $promise: new Promise((o, t) => {
      e = o, r = t;
    }),
    resolve: e,
    reject: r
  };
}();
export {
  n as I
};
